import './Utils';
import './RenderContext';
import './Series';
import './Renderer';
import './ChartOptions';
import './Marker';
import {ChartOptions, IChartOptions} from './ChartOptions';
import {RenderContext} from './RenderContext';
import {IRenderer, Renderer} from './Renderer';
import {AxesConfiguration, Axis} from './Axis';
import {Series, SeriesConfiguration} from './Series';
import {Marker} from './Marker';
import {SlideChart} from './charts/slide-chart/SlideChart';
import * as JQuery from 'jquery';
    export class Chart {

        public options: IChartOptions;
        public context: RenderContext;
        public renderer: IRenderer<RenderContext>;

        public constructor(container: string | Element | JQuery) {
            this.options = new ChartOptions();
            this.context = this.createRenderContext(container);
            this.renderer = this.createRenderer();
        }

        protected createRenderer() {
            console.log('Create base renderer');
            return new Renderer();
        }

        protected createRenderContext(container: string | Element | JQuery) {
            console.log('Create base render context');
            return new RenderContext(container);
        }

        public setAxes(xAxis: Axis, yAxis: Axis) {
           this.context.axesConfiguration = new AxesConfiguration([xAxis, yAxis]);
        }

        public setSeries(...series: Series<any>[]) {
            this.context.seriesConfiguration = new SeriesConfiguration(series);
        }

		public setMarkers(markers: Marker[]){
			this.context.markers = markers || [];
		}

        public redraw() {
            this.context.onResize();
            this.context.axesConfiguration.scale(this.context);
            this.context.gridConfiguration.calculate(this.context, this.options);
            this.renderer.render(this.context, this.options);
        }

        public onResize() {
            this.context.onResize();
            this.redraw();
		}

        public destroy() {
        	this.context.getAllLayers().remove();
        }

    }
